import React from 'react';
import type { TableState } from 'react-table';
import type { RoutesPlannerTask } from '../../../types';

const getSelectedGroupByIdMap = (selectedRuns: Set<number>) => {
	const selectedGroupIdsMap = {};

	selectedRuns.forEach(runId => {
		selectedGroupIdsMap[runId] = true;
	});

	return selectedGroupIdsMap;
};

const useTableControlledState = (state: TableState<RoutesPlannerTask>, selectedRuns: Set<number>) => {
	return React.useMemo(() => {
		return {
			...state,
			selectedGroupIds: getSelectedGroupByIdMap(selectedRuns)
		};
	}, [state, selectedRuns]);
};

export default useTableControlledState;
